import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    Card,
    Container,
    Col,
    Button,
    Spinner,
    FormGroup,
    Row,
    Pagination,
    CardBody,
    CardTitle,
    CardSubtitle,
    CardText
} from "reactstrap";
import { AvForm } from "availity-reactstrap-validation";
import Select, { components } from "react-select";

import {
    portalOptionJenisBarang,
    portalOptionProvinsi,
    portalOptionSupplier,
    portalViewProduct,
} from "./../../../../actions/portalAction";

import { UPLOAD_URL } from "./../../../../actions/constant";
import imgDummy from "../../../../assets/img/img-dummy.png";

const ProdukPortal = (props) => {
    const dispatch = useDispatch();

    const { portals } = useSelector((state) => {
        return state;
    });

    // console.log("PORTALS ===>>> ", portals);

    const [page, setPage] = useState(1);
    const [sizePage] = useState(12);
    const [sizePerPage, setSizePerPage] = useState([]);
    const [totalSize, setTotalSize] = useState(0);

    const [searchParams, setSearchParams] = useState({
        id_jenis_barang: null,
        provinsi_id: null,
        supplier_id: null,
    });

    useEffect(() => {
        if (portals.portalViewProduct.success) {
            let totalData = portals.portalViewProduct.payload.total_page || 0;
            let totalSizeSet = Math.ceil(totalData / sizePage);
            setTotalSize(totalSizeSet);
        }
    }, [portals.portalViewProduct, sizePage]);

    useEffect(() => {
        dispatch(
            portalViewProduct({
                limit: 12,
                page: 1,
            })
        );

        dispatch(portalOptionJenisBarang());
        dispatch(portalOptionProvinsi());
        dispatch(portalOptionSupplier());
    }, [dispatch]);

    useEffect(() => {
        let totalsize = totalSize;
        let size_per_page = 5;

        let prev = page > size_per_page - 2 ? page - 2 : 1;
        let stop =
            totalsize < 5
                ? totalsize
                : page < size_per_page - 2
                ? size_per_page
                : page < totalsize - 2
                ? page + 2
                : totalsize;
        let newDataSizePerPage = [];

        if (totalsize > 1) {
            for (var i = prev; i <= stop; i++) {
                newDataSizePerPage.push(i);
            }
        } else {
            newDataSizePerPage = [];
        }

        setSizePerPage(newDataSizePerPage);
    }, [dispatch, page, sizePage, totalSize]);

    const handlePagination = (page) => {
        setPage(page);
        dispatch(
            portalViewProduct({
                ...searchParams,
                limit: sizePage,
                page: page,
            })
        );
    };

    const handleSubmit = () => {
        dispatch(
            portalViewProduct({
                ...searchParams,
                limit: sizePage,
                page: 1,
            })
        );
        setPage(1);
    };

    const handleSelect = (value, name) => {
        setSearchParams({
            ...searchParams,
            [name]: value ? value.value : null,
        });
    };

    const DropdownIndicator = (props) => {
        return (
            components.DropdownIndicator && (
                <components.DropdownIndicator {...props}>
                    <i
                        className="fa fa-caret-down"
                        style={{ color: "#224B98" }}
                        aria-hidden="true"
                    ></i>
                </components.DropdownIndicator>
            )
        );
    };

    const customStyle = {
        control: (base) => ({
            ...base,
            border: 0,
            // This line disable the blue border
            color: "red",
            backgroundColor: "#edf3ff",
            boxShadow: "none",
        }),
    };

    const Control = ({ children, ...props }) => (
        <components.Control {...props} style={{ borderRadius: "25px" }}>
            {props.selectProps.id === "jenis_barang" ? (
                <i
                    className="fa fa-shopping-bag"
                    style={{ color: "#224B98" }}
                    aria-hidden="true"
                ></i>
            ) : props.selectProps.id === "provinsi" ? (
                <i className="fa fa-map-marker" style={{ color: "#224B98" }} aria-hidden="true"></i>
            ) : (
                props.selectProps.id === "supplier" && (
                    <i
                        className="fa fa-building-o"
                        style={{ color: "#224B98" }}
                        aria-hidden="true"
                    ></i>
                )
            )}{" "}
            {children}
        </components.Control>
    );

    const IconOption = (props) => (
        <components.Option {...props}>{props.data.label}</components.Option>
    );

    const ErrroImg = (ev) => (
        ev.target.src = imgDummy
    );

    return (
        <div style={{ backgroundColor: "#3B6ECE", display: "flex", justifyContent: "center" }}>
            <Container>
                <Card
                    style={{ position: "relative", top: -70, padding: "0 28px", borderRadius: 30 }}
                >
                    <AvForm
                        onValidSubmit={handleSubmit}
                        style={{
                            backgroundColor: `rgba(${109}, ${157}, ${249}, ${0.12})`,
                            margin: "34px 0 10px",
                            padding: "30px 30px 14px",
                            borderRadius: 10,
                        }}
                    >
                        <Row>
                            <Col md="12" lg="">
                                <FormGroup>
                                    <Select
                                        id="jenis_barang"
                                        name="jenis_barang"
                                        placeholder="-- Jenis Barang --"
                                        isDisabled={portals.portalOptionJenisBarang.loading}
                                        // value={this.state.port_origin.port_origin}
                                        // defaultValue={}
                                        onChange={(opt) => handleSelect(opt, "id_jenis_barang")}
                                        isClearable
                                        styles={customStyle}
                                        components={{
                                            Control,
                                            Option: IconOption,
                                            DropdownIndicator,
                                            IndicatorSeparator: () => null,
                                        }}
                                        options={portals.portalOptionJenisBarang.payload?.data}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="12" lg="">
                                <FormGroup>
                                    <Select
                                        id="provinsi"
                                        name="provinsi"
                                        placeholder="-- Provinsi --"
                                        isDisabled={portals.portalOptionProvinsi.loading}
                                        // value={this.state.port_origin.port_origin}
                                        // defaultValue={}
                                        onChange={(opt) => handleSelect(opt, "provinsi_id")}
                                        isClearable
                                        styles={customStyle}
                                        components={{
                                            Control,
                                            Option: IconOption,
                                            DropdownIndicator,
                                            IndicatorSeparator: () => null,
                                        }}
                                        options={portals.portalOptionProvinsi.payload?.data}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="12" lg="">
                                <FormGroup>
                                    <Select
                                        id="supplier"
                                        name="supplier"
                                        placeholder="-- Supplier --"
                                        isDisabled={portals.portalOptionSupplier.loading}
                                        // value={this.state.port_origin.port_origin}
                                        // defaultValue={}
                                        onChange={(opt) => handleSelect(opt, "supplier_id")}
                                        isClearable
                                        styles={customStyle}
                                        components={{
                                            Control,
                                            Option: IconOption,
                                            DropdownIndicator,
                                            IndicatorSeparator: () => null,
                                        }}
                                        options={portals.portalOptionSupplier.payload?.data}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="12" lg="auto">
                                <Button
                                    className="w-100"
                                    style={{ backgroundColor: "#224B98", color: "white" }}
                                    type="submit"
                                    disabled={portals.portalViewProduct.loading}
                                >
                                    <i className="fa fa-search"></i>
                                </Button>
                            </Col>
                        </Row>
                    </AvForm>

                    {portals.portalViewProduct.loading ? (
                        <div className='d-flex justify-content-center align-items-center vh-100'>
                            <Spinner color="primary" size="lg" />
                        </div>
                    ) : 
                    portals.portalViewProduct.success &&
                    portals.portalViewProduct.payload !== null &&
                    portals.portalViewProduct.payload.total_page > 0 ? (
                        <Row>
                        {portals.portalViewProduct.payload.data.map((item, index) => {
                            return (
                                <>
                                <Col xs="3">
                                    <Card
                                        key={index}
                                    >
                                        <div
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                padding: '15px'
                                            }}
                                        >
                                            <img
                                                alt="produk_img"
                                                src={UPLOAD_URL + item.gambar}
                                                style={{
                                                    height: '150px',
                                                    width: '150px'
                                                }}
                                                onError={ErrroImg}
                                            />
                                        </div>

                                        <CardBody>
                                            <CardTitle tag="h5">
                                                {item.nama_barang}
                                            </CardTitle>
            
                                            <CardSubtitle
                                                className="mb-2 text-muted"
                                                tag="h6"
                                            >
                                                Rp. {Intl.NumberFormat().format(item.harga_satuan)} / {item.satuan}
                                            </CardSubtitle>
                
                                            <CardText>
                                                Supplier : {item.nama_supplier} <br/>
                                                Jenis Barang : {item.jenis_barang} <br/>
                                                Jenis Komoditi : {item.jenis_commodity}<br/>
                                            </CardText>
                                        </CardBody>
                                    </Card>
                                </Col>
                                </>
                            );
                        })}
                        </Row>
                    ) : (
                        <p>Data tidak ditemukan</p>
                    )}

                    <div className="d-flex justify-content-center my-3">
                        <Pagination>
                            {sizePerPage.map((i, k) => {
                                let number_page = i;
                                let is_active = number_page === page;
                                return (
                                    <li
                                        className={`page-item ${is_active ? "active" : ""}`}
                                        key={k}
                                    >
                                        {is_active ? (
                                            <span className="page-link">{number_page}</span>
                                        ) : (
                                            <button
                                                className="page-link"
                                                onClick={() => handlePagination(number_page)}
                                                // disabled={masterHargaGetLoading}
                                            >
                                                {number_page}
                                            </button>
                                        )}
                                    </li>
                                );
                            })}
                        </Pagination>
                    </div>
                </Card>
            </Container>
        </div>
    );
};

export default ProdukPortal;
